export const CLIENT_AUDIO_EDIT_MODAL_NAME = 'clientAudioEdit' as const;
